import type { Variants } from "framer-motion";

// Shared easing — matches the "emphasized" curve in tailwind.config.js
const ease = [0.16, 1, 0.3, 1] as const;

/** Cards, list rows, and any element entering from slightly below. */
export const fadeInUp: Variants = {
  hidden: { opacity: 0, y: 14 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.35, ease },
  },
  exit: {
    opacity: 0,
    transition: { duration: 0.15 },
  },
};

/** Headings, page sections, empty states. */
export const fadeIn: Variants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.22 } },
  exit: { opacity: 0, transition: { duration: 0.15 } },
};

/**
 * Parent container that staggers its children.
 * Children should carry `variants={fadeInUp}` (no own initial/animate needed —
 * Framer Motion propagates state through the tree).
 */
export const stagger: Variants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.055,
      delayChildren: 0.04,
    },
  },
};
